import { useStyles } from "./Friends.style";
import { useEffect, useMemo } from "react";
import clsx from "classnames";
import {
  FriendCard,
  FriendCardLoading,
} from "../../components/common/FriendCard";
import { useAppSelector } from "../../components/hooks";
import { useQuery } from "@apollo/client";
import { FollowSuggestion, User } from "@onmo/graphql/graphql";
import { getConfigGQL } from "../../graphql";
import { FriendEmpty } from "../../components/common/FriendEmpty";
import { LoadMore } from "../../components/common/LoadMore";
import {
  useFetchFollowers,
  useFetchFollowing,
  useFetchFollowSuggestions,
} from "../../hooks/resolvers/friend/friend";

const Friends: React.FC = () => {
  const classes = useStyles();
  const { friendActiveTab } = useAppSelector((state) => state.friends);
  const { data: dataConfig } = useQuery(getConfigGQL);
  const {
    followingResponse,
    loadMore: fetchMoreFollowing,
    loading: followingLoading,
  } = useFetchFollowing();

  const {
    followersResponse,
    loadMore: fetchMoreFollowers,
    loading: followersLoading,
  } = useFetchFollowers();
  const { followSuggestions, refetch: refetchFollowSuggestions } =
    useFetchFollowSuggestions();

  const onFetchMore = async () => {
    if (!currentFriendList?.length || friendActiveTab === "Suggestions") return;
    if (friendActiveTab?.startsWith("Following")) {
      fetchMoreFollowing();
    } else {
      fetchMoreFollowers();
    }
  };

  const currentFriendList = useMemo(() => {
    switch (friendActiveTab) {
      case "Suggestions":
        return followSuggestions;
      case "Followers":
        return followersResponse?.items;
      case "Following":
        return followingResponse?.items;
      default:
        return followSuggestions;
    }
  }, [
    friendActiveTab,
    followSuggestions,
    followersResponse,
    followingResponse,
  ]);

  useEffect(() => {
    if (friendActiveTab === "Suggestions") {
      refetchFollowSuggestions();
    }
  }, [friendActiveTab]);

  return (
    <div className={classes.root}>
      {currentFriendList?.length === 0 ? (
        <FriendEmpty />
      ) : (
        <div className={clsx(classes.content)}>
          {!currentFriendList
            ? Array.from(new Array(6)).map((_, index) => (
                <FriendCardLoading key={index} />
              ))
            : (currentFriendList as (User | FollowSuggestion)[])?.map(
                (item) => {
                  const user = "user" in item ? item.user : item;
                  if (!user) return null;
                  return (
                    <FriendCard
                      key={user?.id}
                      user={user}
                      criteria={"user" in item ? item?.criteria : undefined}
                      tierLevels={dataConfig?.config.tierLevels}
                    />
                  );
                },
              )}
          {(followersLoading || followingLoading) && <FriendCardLoading />}
          <LoadMore loadMore={onFetchMore} />
        </div>
      )}
    </div>
  );
};

export default Friends;
